import { cn } from "@/lib/utils";

export function SectionLabel({
  children,
  className,
  trailing,
}: {
  children: React.ReactNode;
  className?: string;
  trailing?: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-between text-[11.5px] font-semibold uppercase tracking-[0.06em]",
        "text-[var(--color-fg-muted)]",
        className,
      )}
    >
      <span>{children}</span>
      {trailing}
    </div>
  );
}
